import React from 'react';

const AddMemberModalSummaryEmptyState = () => (
  <>
    <div className="h4 mb-0">You haven&apos;t uploaded any members yet.</div>
    <span className="small">Upload a CSV file or select members to get started.</span>
  </>
);

export default AddMemberModalSummaryEmptyState;
